async function getQuantityAndAddProductToCart(product, variant) {
  let queryParams = null
  let queryVariantId = null
  if (location.search) {
    queryParams = location.search.substring(1, location.search.length).split(',')
    let queryArray = queryParams.find(query => query.startsWith('variant='))
    if (queryArray) {
      queryVariantId = queryArray.split('=')[1]
    }
  }
  showCartDrawer()
  const productsDisplay = document.querySelector('.products-display')
  const loaderContainer = document.createElement('div')
  loaderContainer.setAttribute('class', 'loader-container')
  loaderContainer.innerHTML = `<span class='loader'></span>`
  productsDisplay.append(loaderContainer)
  const quantityInputElement = document.querySelector('quantity-input .quantity__input')
  await showRecommendations(product && product.id)
  if (queryVariantId && queryVariantId != variant.id) {
    await addProductToCart({ product, variant, variantId: queryVariantId, amount: quantityInputElement.value, updateUiOnly: true, fromRecommend: false })
  } else {
    await addProductToCart({ product, variant, variantId: variant && variant.id, amount: quantityInputElement.value, updateUiOnly: true, fromRecommend: false })
  }


if (typeof productObject1 != 'undefined' && typeof variantObject1 != 'undefined') {
    const variantId1 = +document.querySelector('[name="items[1][id]"]').value
    await addProductToCart({ product:productObject1, variant:variantObject1, variantId: variantId1, amount: quantityInputElement.value, updateUiOnly: true, fromRecommend: false })
  }
  
  updateCartPoints()
}

(function(){

  document.addEventListener('spicegemsAddon:added', async function(e){
    // console.log('addon Added...');
    let addonData = spiceAllAddonsData;
    let cartItems = e.detail.items;
    let currentCart = await getCart();
    let updatedCart = null;

    setTimeout(()=>{
      cartItems.forEach((item) => {
        let productId = item.product_id;
        let variantId = item.id;
        let product = addonData.filter(item => item.id == productId)[0];
        let variant = product.variants.filter(item => item.id == variantId)[0];
        let amount = item.quantity;

        let updatedProduct = currentCart && currentCart.items && currentCart.items.find((item) => item.variant_id == variantId);
        updatedProduct.product = variant;
        updatedProduct.product.tags = product ? product.tags.join(',') : '';
        updatedProduct.product.metafields = { ghs: { points: 0, multiplier: 1 }};
        addProduct(updatedProduct)
        updateProductValues(variantId, updatedProduct, updatedCart ? updatedCart : currentCart)
      })
    },1000)

  })
}())
function updateAffirmText() {
    let updated = false;
    
    document.querySelectorAll('.affirm-as-low-as').forEach((el) => {
        el.childNodes.forEach((node) => {
            if (node.nodeType === 3 && node.textContent.includes('$50')) {
                node.textContent = node.textContent.replace('$50', '$250');
                updated = true;
            }
        });
    });
    
    return updated;
}

// Run immediately, then use interval if needed
if (!updateAffirmText()) {
    const affirmInterval = setInterval(() => {
        if (updateAffirmText()) {
            clearInterval(affirmInterval);
        }
    }, 500);
    
    // Stop after 5 seconds
    setTimeout(() => {
        clearInterval(affirmInterval);
    }, 5000);
}

